(function () {
  var DESKTOP = '(min-width: 990px)';

  function syncAccordions(root, initial) {
    var details = root.querySelectorAll('[data-footer-accordion]');
    var isDesktop = window.matchMedia(DESKTOP).matches;

    details.forEach(function (el) {
      var summary = el.querySelector('summary');
      if (isDesktop) {
        el.open = true;
        el.dataset.lockedOpen = 'true';
        summary.setAttribute('tabindex', '-1');
      } else {
        if (initial || el.dataset.lockedOpen === 'true') el.open = false;
        delete el.dataset.lockedOpen;
        summary.removeAttribute('tabindex');
      }
    });
  }

  function bindAccordions(root) {
    root.querySelectorAll('[data-footer-accordion]').forEach(function (el) {
      el.querySelector('summary').addEventListener('click', function (event) {
        if (window.matchMedia(DESKTOP).matches) event.preventDefault();
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.merooFooterReady === 'true') return;
    root.dataset.merooFooterReady = 'true';
    bindAccordions(root);
    syncAccordions(root, true);
  }

  function boot() {
    document.querySelectorAll('[data-meroo-footer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-meroo-footer]').forEach(function (root) {
      syncAccordions(root, false);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event.target;
    if (!sectionRoot) return;
    var footer = sectionRoot.matches('[data-meroo-footer]')
      ? sectionRoot
      : sectionRoot.querySelector('[data-meroo-footer]');
    if (footer) {
      footer.dataset.merooFooterReady = 'false';
      init(footer);
    }
  });
})();
